import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
function Kyagu4({ lang }) {
  const k4 =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fk04.png?alt=media&token=83334d6a-f5ca-4e5f-bb2b-22de230a76b5';
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Row className='kyaguContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center'>
              {/* Header Image */}
              <Image src={k4} rounded fluid />
              {/* Title */}
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese mb-3 '>
                  慮美多傑 1227-1292
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                  བོད་ཡིག་
                </h3>
              ) : (
                <h3 className='text-left text-secondary mb-3'>English</h3>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Tab.Container id='left-tabs' defaultActiveKey='1'>
                <Row>
                  <Col sm={5} md={3}>
                    <Nav variant='pills' className='flex-column '>
                      {/* Tap 1 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='1'>
                          {lang === 'CH' ? (
                            <h4>自傳</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྣམ་ཐར།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 2 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='2'>
                          {lang === 'CH' ? (
                            <h4>大手印</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཕྱག་ཆེན། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 3 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='3'>
                          {lang === 'CH' ? (
                            <h4>那若六法</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཆོས་དྲུག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 4 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='4'>
                          {lang === 'CH' ? (
                            <h4>道歌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྡོ་རྗེས་མགུར། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 5 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='5'>
                          {lang === 'CH' ? (
                            <h4>教言</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཞལ་གདམ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 6 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='6'>
                          {lang === 'CH' ? (
                            <h4>儀軌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདོན་ཆ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 7 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='7'>
                          {lang === 'CH' ? (
                            <h4>法相</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདྲ་འབག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 8 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='8'>
                          {lang === 'CH' ? (
                            <h4>法帽</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དབུ་ཞྭ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 9 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='9'>
                          {lang === 'CH' ? (
                            <h4>佛寺</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དགོན་པ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 10 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='10'>
                          {lang === 'CH' ? (
                            <h4>閉關地</h4>
                          ) : lang === 'TIB' ? (
                            <h4>སྒྲུབ་གནས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 11 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='11'>
                          {lang === 'CH' ? (
                            <h4>加持物</h4>
                          ) : lang === 'TIB' ? (
                            <h4>བྱིན་རླབས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 12 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='12'>
                          {lang === 'CH' ? (
                            <h4>紀念法會</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདས་མཆོད། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  {/* Content */}
                  <Col sm={7} md={9}>
                    <Tab.Content className='tabContent'>
                      <Tab.Pane eventKey='1' className='tabPane'>
                        {lang === 'CH' ? (
                          <p className='chineseParagraph p-2'>
                            慮美多傑生於在多康六地之一的上部止隆地區。由於宿緣傾心佛法，比較容易地掌握了藏文讀寫。一次，爲建六地萬戶的修行殿，而來到固本寺，油然生起敬仰之心，不顧身命地努力修建佛殿，因而清除了惡障。佛殿落成時，瑞巴卡波騎馬來到楚康囊爲參加建寺的六地工人講法。瑞巴卡波臨走時，發現慮美多傑是一位有緣分的人，能夠肩負利益衆生的重擔。於是，問他：「你在這裏出家，能否修行佛法?」無體金剛頓時興奮不抑，淚流滿面的說：「我無論如何將隨侍上師，請收容。」瑞巴卡波也格外高興從此，無身金剛離開親戚鄰舍獨居修行。不久，從瑞巴卡波等受出家戒，取名絳曲貝
                            (菩提祥)，聽講戒律及其它法門。求得勝樂、喜金剛、摩訶摩衍等灌頂，取秘號彌覺多傑
                            (不動金剛)。聞習完全部教授次第法後，絳曲貝專心修煉大手印法，體悟心境一體，獲得大神通。他在此興建了一座名為囊索·謙摩的寺院，囊謙就是因這座寺院而得名有一百五十根柱子支撐的囊索·謙摩寺顯得龐大壯觀。寺院開光慶典期間受功德主之邀，師徒十八人前往應供時，慮美多傑在眾人面前享用了一鍋又一鍋的卓瑪（一種浸泡在提煉過的牛油裏，非常油膩的根莖類甜點），於是謠言四起，大家都擔心他將會死掉，不死也會病的很重。，上師瑞巴卡波說：「（慮美多傑）有很好的氣脈明點修持，應該不會有事，不然妳們去看看怎樣了。」於是大家前往查看時，發現其坐在一處岩石上，擺出瑜珈姿態修氣脈明點時，之前吃下的酥油皆從身體的毛孔中排放出，讓自己比以前更加光芒四射。他白天散發日光，夜晚散發月光和油燈光，行向何處都沒有身影，故人稱「慮美」(無身)。上師圓寂後，他爲上師舉行了忌日法會，前往前藏從歐色傑紮巴學習喜金剛、本尊都索瑪，以及戒律；在蔡貢塘從拉浦尼瑪沃聞習《五釘》等蔡巴教法；從恰域寺僧人學習經論。那時，薩迦派喇嘛八思巴
                            (1235-1280)
                            從蒙古進藏途經多麥，固本寺的全體老僧前去拜見，敬獻禮物，請求八思巴說：「上師的化身已去佛國，現在您是西藏全體人民的主人，請爲我們上師的寺院委任一名上師。」八思巴說：「我們教派不同，如果委派我宗喇嘛不合適，委任你自己的弟子中較有影響的一位作上師，這樣符合我的做法。」老僧們說：「有一位上師的心傳弟子慮美多傑，現在他住在衛藏。」八思巴說：「如果這樣，派人去把他叫到我跟前來。」慮美多傑駐錫蔡貢塘寺時，八思巴從薩迦寺派差使來，要他去擔任固本寺上師並為他升座，授予他（拉纖）的地位，成為十三位皇族教師之一。當他到達康區時，受到固本雜哇寺全體僧人和六地僧俗部衆的隆重迎接，從此，他更加學習三戒和三學，努力鑽研顯密教法，利用一切時間修煉，智慧達到圓滿。慮美多傑讓佛法興盛於整個囊謙，並用他的靈性影響力讓整個王國以禪修者之鄉著稱。水龍年
                            (1292)
                            二月初八日示現涅盤相，享年六十六歲。遺體火化之日，天空彩虹密布，花雨飄落，火化後遺骨上出現十三顆右旋螺舍利等，連續七晝夜天降舍利雨。而慮美多傑有眾多弟子當中，最重要的有四位，分別是蔣確修努
                            、絳曲滾波、拉巴次程僧格、釋迦多傑。
                          </p>
                        ) : lang === 'TIB' ? (
                          <p>
                            <h1>བོད་ཡིག་</h1>
                          </p>
                        ) : (
                          <p>
                            <h1>English</h1>
                          </p>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey='second' className='tabPane'>
                        <p>i am Singapore</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='third' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='forth' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu4);
